import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../hooks/useFetch";
import Swal from "sweetalert2";

// https://dev.to/bytebodger/constructors-in-functional-components-with-hooks-280m
// https://reactjs.org/docs/hooks-state.html
// https://beta.reactjs.org/reference/react/useRef
// https://ui.dev/react-router-pass-props-to-link

export default function Categoria() {
    const navigate = useNavigate();
    const { get, post, put } = useFetch();
    const defaultState = {
        acao: "Visualizar",
        categoria: { id_categoria: "", nome_cat: "", descricao: "" }
    }

    /* objeto recebido do state={} do <Link> da página anterior
    ** https://v5.reactrouter.com/web/api/location  https://v5.reactrouter.com/web/api/Hooks/uselocation */
    let location = useLocation();

    // https://v5.reactrouter.com/web/example/url-params
    let { id } = useParams();

    useEffect(() => {
        if (id === "criar")
            setState({ ...state, acao: "Criar" });
        else
            buscarCategoria(id).then(data => setState({ ...state, categoria: data }));
    }, [id])


    /* https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    ** define o state inicial do componente, o useState retorna um array com 2 elementos, 
    ** objeto state e função setState pra atualizar o objeto state */
    const [state, setState] = useState(() => {
        // se a página anterior passou um state, retorna ele
        if (location.state) {
            if (location.state.acao) {
                defaultState.acao = location.state.acao;
            }
        }
        // senão, retorna um objeto vazio
        return defaultState;
    });

    /* https://reactjs.org/docs/hooks-reference.html#functional-updates
    ** handleChange: quando um campo do formulário é alterado, atualiza o objeto state */
    function changeCategoria(event) {
        let name = event.target.name; // name do campo que disparou o evento
        let value = event.target.value; // value do campo    

        // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
        // { Nome: "novo valor do campo Nome" }
        setState(prevState => ({
            ...prevState,
            categoria: {
                ...prevState.categoria,
                [name]: value
            }
        }));
    }

    async function buscarCategoria(id) {
        try {
            let response = await get("/categoria/" + id);
            if (response.status === 200) {
                let dados = response.result.data;
                if (dados === null)
                    return defaultState.categoria;
                return dados;
            } else {
                return defaultState.categoria;
            }
        } catch (error) {
            console.error("Erro no buscarCategoria():", error);
            return defaultState.categoria;
        }
    }

    async function salvarCategoria() {
        let method = state.acao === "Criar" ? post : put;
        try {
            let response = await method(`/categoria/${state.categoria.id_categoria}`, state.categoria);
            if (response.status === 201 || response.status === 200) {
                navigate("/admin/categorias");
            } else {
                Swal.fire({
                    title: "Não foi possível salvar a categoria",
                    text: "Erro ao salvar categoria",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Erro no salvarCategoria():", error);
        }
    }

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/categorias" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar às Categorias
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4">
                    <div className="section-title-modern mb-4">
                        <div className="title-accent"></div>
                        <h2 className="admin-title">{state.acao} Categoria</h2>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Nome da Categoria</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="input-moderno"
                                    name="nome_cat"
                                    placeholder="Ex: Equipamentos de Proteção"
                                    value={state.categoria.nome_cat ?? ""}
                                    onChange={changeCategoria}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={45}
                                />
                            </Form.Group>
                            
                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">Descrição Detalhada</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    className="input-moderno"
                                    name="descricao"
                                    placeholder="Descreva o propósito desta categoria..."
                                    value={state.categoria.descricao ?? ""}
                                    onChange={changeCategoria}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={255}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvarCategoria}>
                                    Salvar Categoria
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}